"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import MetaPixel from "@/app/[locale]/(site)/metaPixel";
import TikTokPixel from "@/app/[locale]/(site)/TikTokPixel";
import LinkedInInsightTag from "@/app/[locale]/(site)/LinkedInInsightTag";
import OpenAIPixel from "@/app/[locale]/(site)/OpenAIPixel";
import { useTrackingConsent } from "@/hooks/useTrackingConsent";
import { ensureGoogleTag, GOOGLE_ADS_TAG_ID } from "@/utils/tracking/googleTag";
function GoogleAdsTag() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}

/**
 * Advertising pixels and the direct Google Ads tag. Nothing here loads, sets
 * cookies or sends events until the visitor accepts advertising cookies.
 */
function _temp() {
  ensureGoogleTag(GOOGLE_ADS_TAG_ID);
}
export default function MarketingTags(t0) {
  const $ = _c(11);
  const {
    metaPageViewEventId
  } = t0;
  const {
    advertisement
  } = useTrackingConsent();
  let t1;
  let t2;
  if ($[0] !== advertisement) {
    t1 = () => {
      if (typeof window.fbq === "function") {
        window.fbq("consent", advertisement ? "grant" : "revoke");
      }
    };
    t2 = [advertisement];
    $[0] = advertisement;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!advertisement) {
    return null;
  }
  let t3;
  if ($[3] !== metaPageViewEventId) {
    t3 = <MetaPixel pageViewEventId={metaPageViewEventId} />;
    $[3] = metaPageViewEventId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <GoogleAdsTag />;
    t5 = <TikTokPixel />;
    t6 = <LinkedInInsightTag />;
    t7 = <OpenAIPixel />;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3) {
    t8 = <>{t3}{t4}{t5}{t6}{t7}</>;
    $[9] = t3;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}